import { formatters } from '@utils/intl/dateTimeFormatters'
import moment from 'moment/moment'

export const getColumnDefs = (dayRangeArray: string[]) => {
  const dates = dayRangeArray.map((day) => ({
    headerName: moment(day).format('M/D'),
    field: `schedule_count.${day}`,
    headerClass: () => {
      const d = formatters.LONG_DAY(day)
      if (d === 'Sunday' || d === 'Saturday') return 'orange-header'
    },
    aggFunc: 'sum',
  }))
  return [
    {
      headerName: 'Market',
      field: 'market',
      rowGroup: true,
      hide: true,
    },
    {
      headerName: 'Depot',
      field: 'depot',
      rowGroup: true,
      hide: true,
    },
    {
      headerName: 'Shift',
      field: 'shift',
      pinned: 'left',
      valueGetter: (params) => {
        if (params?.data?.shift === 'am') return `Morning`
        if (params?.data?.shift === 'pm') return `Evening`
      },
    },
    ...dates,
  ]
}
